export default __webpack_public_path__ + "static/media/copy_black.8982da22.svg";